(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veylo-sky-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('veylo-sky-collection')) {
  customElements.define('veylo-sky-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('[data-sky-sort]').addEventListener('change', event => {
        const url = new URL(location.href); url.searchParams.set('sort_by',event.target.value); url.searchParams.delete('page'); location.assign(url);
      });
      this.addEventListener('click', async event => {
        const link = event.target.closest('[data-sky-load]');
        if (!link || this.loading) return;
        event.preventDefault(); this.loading=true; link.setAttribute('aria-disabled','true'); this.setAttribute('aria-busy','true');
        try {
          const url = new URL(link.href); url.searchParams.set('section_id',this.dataset.sectionId);
          const response = await fetch(url);
          if (!response.ok) throw new Error('Load failed');
          const page = new DOMParser().parseFromString(await response.text(),'text/html');
          const grid = page.querySelector('[data-sky-grid]'); const more = page.querySelector('[data-sky-more]');
          if (!grid || !more) throw new Error('Missing grid');
          this.querySelector('[data-sky-grid]').append(...grid.children);
          this.querySelector('[data-sky-more]').replaceWith(more);
        } catch { location.assign(link.href); }
        finally { this.loading=false; this.removeAttribute('aria-busy'); }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veylo-sky-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('veylo-sky-navigation')) {
  customElements.define('veylo-sky-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      this.querySelectorAll('[data-sky-menu-open]').forEach(button => button.addEventListener('click', () => dialog.showModal()));
      this.querySelector('[data-sky-menu-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      this.querySelector('[data-sky-search]').addEventListener('click', () => { window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); this.querySelector('input[type="search"]').focus({preventScroll:true}); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veylo-sky-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('veylo-sky-home')) {
  customElements.define('veylo-sky-home', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('[data-sky-carousel]');
      const slides = track.querySelectorAll('.sky-hero-slide');
      const counter = this.querySelector('[data-sky-counter]');
      const update = () => { counter.textContent = (Math.round(track.scrollLeft / track.clientWidth) + 1) + ' / ' + slides.length; };
      this.querySelectorAll('[data-sky-prev],[data-sky-next]').forEach(button => button.addEventListener('click', () => {
        let index = Math.round(track.scrollLeft / track.clientWidth);
        index = (index + (button.hasAttribute('data-sky-next') ? 1 : -1) + slides.length) % slides.length;
        track.scrollTo({left:index*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
